
const localStr = localStorage;

const storage = {
    setStorage(name:string,value:string){
        localStr.setItem(name, value);
    },
    getStorage(name:string){
        return localStr.getItem(name);
    },
    removeStorage(name:string){
        localStr.removeItem(name);
    }
}

export default storage;